import { createContext, useContext, useState } from "react";
import { Lock } from "lucide-react";

const PermissionModalContext = createContext();

export const PermissionModalProvider = ({ children }) => {
  const [permissionError, setPermissionError] = useState(null);

  const closeModal = () => {
    setPermissionError(null);
  };

  const goBack = () => {
    setPermissionError(null);
    window.history.back();
  };

  return (
    <PermissionModalContext.Provider value={{ permissionError, setPermissionError }}>
      {children}

      {permissionError && (
        <div className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white rounded-2xl shadow-2xl w-[420px] p-6 animate-fadeIn">

            {/* Icon */}
            <div className="flex justify-center mb-4">
              <div className="bg-red-100 p-3 rounded-full">
                <Lock className="text-red-600 w-8 h-8" />
              </div>
            </div>

            {/* Title */}
            <h2 className="text-xl font-bold text-center text-red-600 mb-2">
              Access Denied
            </h2>

            {/* Message */}
            <p className="text-center text-gray-700 mb-3">
              You do not have permission to access this section.
            </p>

            {/* Permission */}
            <div className="bg-gray-100 rounded-lg px-4 py-3 mb-3 text-center">
              <p className="text-sm text-gray-500">Required Permission</p>
              <p className="font-semibold text-gray-800">
                {permissionError.replace(".", " ").toUpperCase()}
              </p>
            </div>

            {/* Page */}
            <p className="text-xs text-center text-gray-400 mb-5">
              Page: {window.location.pathname}
            </p>

            {/* Buttons */}
            <div className="flex gap-3">
              <button
                onClick={goBack}
                className="flex-1 bg-gray-200 hover:bg-gray-300 py-2 rounded-lg font-medium"
              >
                Go Back
              </button>

              <button
                onClick={goBack}
                className="flex-1 bg-red-500 hover:bg-red-600 text-white py-2 rounded-lg font-medium"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </PermissionModalContext.Provider>
  );
};

export const usePermissionModal = () => useContext(PermissionModalContext);